module.exports = __webpack_public_path__ + "static/clynical-analysis-6df4083a479973df687569447a1b16a5.png";